import { isPlatformBrowser } from '@angular/common';

export function jwtOptionsFactory(platformId: Object) {
  return {
    tokenGetter: () => {
      if (isPlatformBrowser(platformId)) {
        return localStorage.getItem('token');
      }
      // Return null or a default value for server-side rendering
      return null;
    },
  };
}